import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component('yearlyPpgTable', {
        template: require('./yearlyPpgTableComponent.html'),
        bindings: {
            statisticalForecast: "<",
            pmForecast: "<",
            parameters: "<",
        },
        controller: ['$scope', angularServicesNames.$translate, 'PPGChartAndTableService', 'dtpChartService', 'ChartsConfig', 'calculationPPGService',
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                PPGChartAndTableService: $TSFixMe,
                dtpChartService: $TSFixMe,
                ChartsConfig: $TSFixMe,
                calculationPPGService: $TSFixMe
            ) {
                var $ctrl = this;

                $ctrl.$onInit = function () {


                    $scope.$watch('$ctrl.pmForecast', function (newVal: $TSFixMe) {
                        if (newVal) {
                            $ctrl.labelsBarChart = PPGChartAndTableService.prepareLabelsToPPG($ctrl.parameters.forecastStartDate, $ctrl.parameters.forecastEndDate);
                            $ctrl.dataToTablePPG = PPGChartAndTableService.prepareDataToPPGYearlyTable($ctrl.statisticalForecast, $ctrl.pmForecast, $ctrl.parameters.forecastStartDate);
                        }
                    });




                };
            }]
    });

})(angular.module('topline.modules'));